// extracted by mini-css-extract-plugin
export var single = "SingleCard-module--single--eca56";
export var singleButtons = "SingleCard-module--singleButtons--c5d8f";
export var singleContainer = "SingleCard-module--singleContainer--a725f";
export var singleContent = "SingleCard-module--singleContent--cdb67";
export var singleDescription = "SingleCard-module--singleDescription--117a8";
export var singleHasDesc = "SingleCard-module--singleHasDesc--0b443";
export var singleHead = "SingleCard-module--singleHead--7aa76";
export var singleHeading = "SingleCard-module--singleHeading--30e4a";
export var singleImage = "SingleCard-module--singleImage--8b665";
export var singleLink = "SingleCard-module--singleLink--7b076";
export var singleLogo = "SingleCard-module--singleLogo--f6b7d";
export var singleSubhead = "SingleCard-module--singleSubhead--9b58c";
export var singleTextLink = "SingleCard-module--singleTextLink--c1937";
export var singleTextLinkIcon = "SingleCard-module--singleTextLinkIcon--f1bac";
export var vcenter = "SingleCard-module--vcenter--d9b91";
export var weddingHeadingColor = "SingleCard-module--weddingHeadingColor--c918e";
export var weddingSubHeadingColor = "SingleCard-module--weddingSubHeadingColor--3bfdd";
export var withDesc = "SingleCard-module--withDesc--c137f";